// Mock the map data
const mapData = [
  {
    name: 'Tulungagung',
    id: 'TU',
    type: 'province',
    coordinate: {
      lat: -7.257537,
      lng: 112.751971,
    },
    markerType: 'ongoing_program',
    link: '/region/detail/1',
    metadata: [
      {
        name: 'Kebijakan',
        count: 1,
        link: '/region/detail/1',
      },
      {
        name: 'Inisiatif',
        count: 10,
        link: '/region/detail/1',
      },
      {
        name: 'Organisasi',
        count: 10,
        link: '/region/detail/1',
      },
      {
        name: 'Kasus',
        count: 3,
        link: '/region/detail/1',
      },
    ]
  },
  {
    name: 'Bangka Belitung',
    id: 'BB',
    type: 'province',
    coordinate: {
      lat: -2.133333,
      lng: 106.116669,
    },
    markerType: 'ongoing_program',
    link: '/region/detail/2',
    metadata: [
      {
        name: 'Kebijakan',
        count: 1,
        link: '/region/detail/2',
      },
      {
        name: 'Inisiatif',
        count: 10,
        link: '/region/detail/2',
      },
      {
        name: 'Organisasi',
        count: 10,
        link: '/region/detail/2',
      },
      {
        name: 'Kasus',
        count: 3,
        link: '/region/detail/2',
      },
    ]
  },
  {
    name: 'Solo',
    id: 'SL',
    type: 'province',
    coordinate: {
      lat: -7.550676,
      lng: 110.828316,
    },
    markerType: 'ongoing_program',
    link: '/region/detail/3',
    metadata: [
      {
        name: 'Kebijakan',
        count: 1,
        link: '/region/detail/3',
      },
      {
        name: 'Inisiatif',
        count: 10,
        link: '/region/detail/3',
      },
      {
        name: 'Organisasi',
        count: 10,
        link: '/region/detail/3',
      },
      {
        name: 'Kasus',
        count: 3,
        link: '/region/detail/3',
      },
    ]
  }
]

export default mapData
